import { render } from "./qxc-basic.vue?vue&type=template&id=1518a77b&scoped=true"
import script from "./qxc-basic.vue?vue&type=script&lang=js"
export * from "./qxc-basic.vue?vue&type=script&lang=js"

import "./qxc-basic.vue?vue&type=style&index=0&id=1518a77b&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1518a77b"]])

export default __exports__